import FlightstatusSearchboxMulti from '../components/FlightStatus/FlightStatusSearchboxMulti'
import Heading from '../components/heading'

Vue.component('page-flightstatus', {

    components: {FlightstatusSearchboxMulti},

    mixins: [Heading],

    data() {
        return {
            heading: null
        }
    },

    mounted() {
        this.heading = this.getQueryVariable('utm_term')
    },

});
